import styled, { css } from "styled-components"
import { Item } from "./styled"
import device from "../../theme/devices"
import { H5 } from "../styles/TextStyles.styled"

export const Card = styled(Item)`
  padding: 10px;
  min-width: 290px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto 1fr auto;
  border-radius: 2px;
  transition: box-shadow 250ms ease-out;

  ${props =>
    props.clickable &&
    css`
      cursor: pointer;
      a span {
        text-decoration: none;
      }
      :hover {
        box-shadow: 0 0 15px rgba(0, 0, 0, 0.35);
        a span {
          text-decoration: underline;
        }
        button {
          transform: translateX(7px);
        }
      }
    `};

  ${props =>
    props.styleVariation === "Light blue"
      ? css`
          background: ${props.theme.secondaryColor};
        `
      : props.styleVariation === "Dark blue"
      ? css`
          background: ${props.theme.backgroundColor};
          color: ${props.theme.primaryColor} !important;
          * {
            color: inherit;
          }
        `
      : css`
          border: 0.5px solid #dfdfdf;
          box-sizing: border-box;
          box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
          background: white;
        `};

  @media (${device.desktop}) {
    padding: 20px;
  }

  &.brand {
    min-height: 150px;

    @media (${device.tablet}) {
      min-height: 300px;
      min-width: 225px;
      max-width: 225px;
    }
  }

  span:first-child {
    min-height: 20px;
    display: block;
    grid-row: 1;
    grid-column: 1;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  .description {
    grid-row: 3;
    grid-column: 1;
    display: block;

    p:first-of-type {
      margin-top: 0;
    }
  }

  .link-wrapper {
    grid-column: 1;
    grid-row: 4;
    margin-top: 20px;
  }
`

export const BrandImgWrapper = styled.div`
  &,
  .gatsby-image-wrapper {
    height: 35px;

    @media (${device.tablet}) {
      height: 45px;
    }
  }
  margin-bottom: 15px;
`

export const Title = styled(H5)`
  font-weight: 600;
  font-size: 32px;
  line-height: 32px;
  margin-top: 0;
  grid-row: 2;
  grid-column: 1;
  display: block;
  ${props =>
    !props.forJobOffer &&
    css`
      font-size: 14px;
      font-weight: 500;
      line-height: 21px;
      margin-bottom: 5px;
    `}
`
